/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const containerStyles = css`
  display: inline-flex;
  flex-direction: column;
  width: 100%;
`;

const StyledInput = styled.input`
  outline: none !important;
  color: ${tokens.color.text_default};
  width: 100%;
  height: 40px;
  background: ${tokens.color.ui_background};
  padding: 0px 12px;
  border: 1px solid ${tokens.color.ui_border};
  border-radius: 2px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.12);
  font-size: 14px;
  line-height: 1.42857143;

  &:hover {
    border-color: ${tokens.color.ui_border_alt};
    ${tokens.elevation(1)};
  }

  &:focus {
    box-shadow: 0 0 0 1px ${tokens.color.ui_background}, 0 0 0 3px ${tokens.color.focus};
  }

  &[disabled] {
    background-color: ${tokens.color.ui_disabled};
    border: 1px solid ${tokens.color.ui_disabled};
    color: ${tokens.color.text_default};
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
  }
`;

const sStyles = css`
  line-height: 1.5;
  width: auto;
  font-size: 12px;
  height: 28px;
  padding: 5px;
  border-radius: 3px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.06);
`;

const lStyles = css`
  font-size: 16px;
  height: 50px;
`;

export const sizeStyles = {
  s: sStyles,
  l: lStyles,
};

export const errorStyles = css`
  border-color: ${tokens.color.ui_border_danger};

  &[disabled] {
    border-color: ${tokens.color.ui_border_danger};
  }
`;

const errorMessageStyles = css`
  color: ${tokens.color.text_danger};
  margin-top: 4px;
  font-size: 12px;
`;

interface InputProps {
  [x: string]: any;
  isError?: boolean;
  size?: 's' | 'l';
  errorMessage?: string;
  inputRef?: React.Ref<any>;
  containerCss?: SerializedStyles | SerializedStyles[];
}

/**
 * @deprecated use hotsauce
 * [`<TextInput />`](https://storybook.hotjar.com/?path=/docs/components-textinput--basic-text-input) or;
 * [`<EmailInput />`](https://storybook.hotjar.com/?path=/docs/components-emailinput--email-input) or;
 * [`<NumberInput />`](https://storybook.hotjar.com/?path=/docs/components-numberinput--basic-number-input) or;
 * [`<TelInput />`](https://storybook.hotjar.com/?path=/docs/components-telinput--simple-tel-input) or;
 * [`<UrlInput />`](https://storybook.hotjar.com/?path=/docs/components-urlinput--url-input) or;
 * just use [`<Field />`](https://storybook.hotjar.com/?path=/docs/components-field--basic-field) for a complete solution
 */
export const Input = ({
  isError,
  size,
  errorMessage,
  inputRef,
  containerCss,
  ...props
}: InputProps): JSX.Element => (
  <div css={[containerStyles, containerCss]}>
    <StyledInput
      css={[isError && errorStyles, size && sizeStyles[size]]}
      ref={inputRef}
      {...props}
    />
    {isError && errorMessage && <div css={errorMessageStyles}>{errorMessage}</div>}
  </div>
);
